import RemoteHeader from "./Header";
import "./index.css";
import { useState } from "react";
import RemoteContents from "./Remote";
import { ShowHide } from "../components/ShowHideCompany";
import FlowNumbersBox from "../components/FlowNumbersBox";
import EPRBox from "../components/EPRBox";
const RemoteComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="remote-container" id="remote-id">
      <RemoteHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        {show && (
          <EPRBox
            businessId={businessId}
            mainBusinessId={mainBusinessId}
            category={"Remote"}
          />
        )}
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 7.2"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && <RemoteContents businessId={businessId} />}
    </div>
  );
};

export default RemoteComponent;
